
import { Channel } from "@/models/chat/channel";
import { ChatState } from "@/utils/chat-state";
import Vue from "vue";
import { ChatService } from "../../services/chat-service";
import { MainSocketService } from "../../services/main-socket-service";

export default Vue.extend({
	data() {
		return {
			channels: ChatService.channels as Channel[],
		};
	},
	props: {
		state: {
			type: Object as () => ChatState,
			required: true
		}
	},
	computed: {},
	watch: {
		"state.conversationUnreads"() {
			let _ = this;
			this.channels.map(function(u: Channel) {
				let unread = _.state.conversationUnreads.find(f => (f.ConversationID == u.ConversationID));
				if (unread) {
					u.Unread = unread.Count;
				}
			});
		}
	},
	methods: {
		onMessageUnread(conversationID: number) {
			this.channels.map(function(u: Channel) {
				if (u.ConversationID == conversationID) {
					if (!u.Unread) {
						u.Unread = 0;
					}
					u.Unread++;
				}
			});
		},
		onMessageRead(conversationID: number) {
			this.channels.map(function(u: Channel) {
				if (u.ConversationID == conversationID) {
					u.Unread = 0;
				}
			});
		}
	},
	async created() {

		this.channels = await ChatService.getChannels();

		for (let channel of this.channels) {
			MainSocketService.on(`/chat/${channel.ConversationID}/conversation/unread`, this.onMessageUnread, this);
			MainSocketService.on(`/chat/${channel.ConversationID}/conversation/read`, this.onMessageRead, this);
		}

	},
	async mounted() {

	},
	beforeDestroy(): void {
		MainSocketService.offAll(this);
	}
});
